import React from 'react'
import { Box } from 'react-bulma-components'
import SidebarContentTitle from '../../components/layout/sidebar/sidebar-content-title'
import { useWorkerCounterTemplateQuery } from '../../queries/worker-counter-templates'
import WorkerCounterTemplatesForm from '../../components/worker-counter-templates/worker-counter-templates-form'
import useUrlId from '../../hooks/use-url-id'
import { useOutletContext } from 'react-router-dom'
import { OutletContext } from './employer-settings-wrapper'

/**
 * Component for managing worker counter template details in settings
 * Uses outlet context to get employer and displays the form with sidebar
 */
const WorkerCounterDetailsSettings: React.FC = () => {
  const { employer } = useOutletContext<OutletContext>()
  const { id, isNew } = useUrlId({ idName: 'workerCounterTemplateId' })

  const { data: workerCounterTemplate } = useWorkerCounterTemplateQuery(id, {
    enabled: Boolean(id && !isNew),
  })

  if (!isNew && !workerCounterTemplate) return null

  return (
    <>
      <SidebarContentTitle
        title={isNew ? 'Nouveau Compteur' : `Compteur ${workerCounterTemplate?.name || ''}`}
      />
      <Box>
        <WorkerCounterTemplatesForm
          workerCounterTemplate={workerCounterTemplate}
          employerId={employer._id}
        />
      </Box>
    </>
  )
}

export default WorkerCounterDetailsSettings
